'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = _glamorous2.default.div(function (_ref) {
  var theme = _ref.theme,
    noContainer = _ref.noContainer;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '64px',
    paddingLeft: noContainer ? theme.space_sm : undefined
  };
});